(function () {
  'use strict';
  const g = window.__whiteelmBsg || (window.__whiteelmBsg = {});

  function bindSectionScrollLinks() {
    if (g.sectionLinksBound) return;
    g.sectionLinksBound = true;
    document.addEventListener('click', function (e) {
      const link = e.target.closest('.size-guide__section-link');
      if (!link) return;
      const target =
        document.getElementById('product-size-guide-section') ||
        document.querySelector('.product-size-guide-section');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function bindModalCloseOnce() {
    if (g.modalCloseBound) return;
    g.modalCloseBound = true;
    document.addEventListener('click', function (e) {
      if (e.target.closest('.bag-size-guide-modal__close')) {
        const modal = document.getElementById('bag-size-guide-modal');
        if (modal) {
          modal.style.display = 'none';
          document.body.classList.remove('js-drawer-open');
          document.body.style.overflowY = 'scroll';
        }
      }
    });
    document.addEventListener('click', function (e) {
      const modal = document.getElementById('bag-size-guide-modal');
      if (
        modal &&
        modal.style.display === 'block' &&
        e.target.classList.contains('bag-size-guide-modal__overlay')
      ) {
        modal.style.display = 'none';
        document.body.classList.remove('js-drawer-open');
        document.body.style.overflowY = 'scroll';
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      const modal = document.getElementById('bag-size-guide-modal');
      if (modal && modal.style.display === 'block') {
        modal.style.display = 'none';
        document.body.classList.remove('js-drawer-open');
        document.body.style.overflowY = 'scroll';
      }
    });
  }

  function openAnglesModal(
    bagSizeGuideModal,
    rootEl,
    collection,
    currentAngle,
    modelName,
    sizeTitle,
    sizeDescription
  ) {
    if (!bagSizeGuideModal || !rootEl) return;
    const titleEl = document.getElementById('size__title');
    const descEl = document.getElementById('size__description');
    const angleEl = document.getElementById('size-image-angle');
    if (titleEl) titleEl.textContent = sizeTitle || modelName || 'Size Guide';
    if (descEl) descEl.textContent = sizeDescription || '';
    if (angleEl) angleEl.textContent = currentAngle || '';

    const modalSlider = bagSizeGuideModal.querySelector('.bag-size-guide-modal__slider');
    const modalThumbnails = bagSizeGuideModal.querySelector('.bag-size-guide-modal__thumbnails');
    if (!modalSlider || !modalThumbnails) return;
    modalSlider.innerHTML = '';
    modalThumbnails.innerHTML = '';

    const modelImages = [];
    rootEl.querySelectorAll('.bag-size-guide__model').forEach(function (model) {
      const modelNameAttr = model.getAttribute('data-model-name');
      const collectionHandle = model.getAttribute('data-collection-handle');
      if (modelNameAttr !== modelName || collectionHandle !== collection) return;
      const angle = model.getAttribute('data-angle');
      const img = model.querySelector('img');
      if (img && angle) {
        modelImages.push({
          angle: angle,
          src: img.getAttribute('src'),
          isCurrentAngle: angle === currentAngle,
        });
      }
    });

    const currentAngleImage = modelImages.find(function (img) {
      return img.isCurrentAngle;
    });
    if (currentAngleImage) {
      const mainImg = document.createElement('img');
      mainImg.setAttribute('src', currentAngleImage.src);
      mainImg.setAttribute('alt', modelName || 'Size guide image');
      modalSlider.appendChild(mainImg);
    }

    modelImages.forEach(function (imageData) {
      const thumbnail = document.createElement('img');
      thumbnail.classList.add('bag-size-guide-modal__thumbnail');
      if (imageData.isCurrentAngle) thumbnail.classList.add('active');
      thumbnail.setAttribute('src', imageData.src);
      thumbnail.setAttribute('alt', 'Angle: ' + imageData.angle);
      thumbnail.setAttribute('data-angle', imageData.angle);
      thumbnail.addEventListener('click', function () {
        const slidedImg = modalSlider.querySelector('img');
        if (slidedImg) slidedImg.setAttribute('src', this.getAttribute('src'));
        modalThumbnails.querySelectorAll('.bag-size-guide-modal__thumbnail').forEach(function (t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
        if (angleEl) angleEl.textContent = this.getAttribute('data-angle') || '';
      });
      modalThumbnails.appendChild(thumbnail);
    });

    bagSizeGuideModal.style.display = 'block';
    document.body.classList.add('js-drawer-open');
    document.body.style.overflow = 'hidden';
  }

  function initProductSizeGuideSection(sectionEl) {
    if (sectionEl.dataset.bsgInitialized) return;
    sectionEl.dataset.bsgInitialized = '1';
    bindModalCloseOnce();

    const bagSizeGuideModal = document.getElementById('bag-size-guide-modal');

    function initDesktopSlider() {
      const sliderPrev = sectionEl.querySelector('.bag-size-guide__slider-prev');
      const sliderNext = sectionEl.querySelector('.bag-size-guide__slider-next');
      const slides = sectionEl.querySelectorAll('.bag-size-guide__slide');
      if (!sliderPrev || !sliderNext || slides.length <= 1) return;
      let currentSlideIndex = 0;
      sliderPrev.addEventListener('click', function () {
        slides[currentSlideIndex].classList.remove('active');
        currentSlideIndex = (currentSlideIndex - 1 + slides.length) % slides.length;
        slides[currentSlideIndex].classList.add('active');
      });
      sliderNext.addEventListener('click', function () {
        slides[currentSlideIndex].classList.remove('active');
        currentSlideIndex = (currentSlideIndex + 1) % slides.length;
        slides[currentSlideIndex].classList.add('active');
      });
    }

    function initShopThisBagButton() {
      const shopThisBagBtn = sectionEl.querySelector('[data-shop-this-bag]');
      if (!shopThisBagBtn) return;
      shopThisBagBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const addToCartBtn = document.querySelector('.product__submit__add[data-add-to-cart]');
        if (addToCartBtn) addToCartBtn.click();
      });
    }

    function initViewMoreAnglesButtons() {
      sectionEl.querySelectorAll('.bag-size-guide-mobile-cards__view-more-btn').forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openAnglesModal(
            bagSizeGuideModal,
            sectionEl,
            this.getAttribute('data-collection'),
            this.getAttribute('data-image-angle'),
            this.getAttribute('data-model-name'),
            this.getAttribute('data-size-title') || '',
            this.getAttribute('data-size-description') || ''
          );
        });
      });
    }

    initDesktopSlider();
    initShopThisBagButton();
    initViewMoreAnglesButtons();
  }

  function initAllProductSections() {
    document.querySelectorAll('.product-size-guide-section').forEach(initProductSizeGuideSection);
  }

  function initSizeChartPopup() {
    if (g.popupInited) return;
    const sizeChartPopup = document.getElementById('size-chart-popup');
    if (!sizeChartPopup) return;
    g.popupInited = true;
    bindModalCloseOnce();

    const bagSizeGuideModal = document.getElementById('bag-size-guide-modal');

    function setupShopThisBagButton() {
      const shopThisBagBtn = sizeChartPopup.querySelector('[data-shop-this-bag]');
      if (!shopThisBagBtn) return;
      shopThisBagBtn.addEventListener('click', function (e) {
        e.preventDefault();
        sizeChartPopup.style.display = 'none';
        document.body.classList.remove('js-drawer-open');
        document.body.style.overflowY = 'scroll';
        const addToCartBtn = document.querySelector('.product__submit__add[data-add-to-cart]');
        if (addToCartBtn) addToCartBtn.click();
      });
    }

    setupShopThisBagButton();

    let originalCollectionHandle = '';

    function getCollectionHandleFromUrl() {
      const pathParts = window.location.pathname.split('/');
      const collectionsIndex = pathParts.indexOf('collections');
      if (collectionsIndex !== -1 && collectionsIndex + 1 < pathParts.length) {
        return pathParts[collectionsIndex + 1];
      }
      const popupEl = document.getElementById('size-chart-popup');
      if (popupEl) {
        const storedHandle = popupEl.getAttribute('data-original-collection-handle');
        if (storedHandle && storedHandle !== '' && storedHandle !== 'all') return storedHandle;
        const contentDiv = popupEl.querySelector('.bag-size-guide__content');
        if (contentDiv) {
          const resolvedHandle = contentDiv.getAttribute('data-resolved-collection-handle');
          if (resolvedHandle && resolvedHandle !== '' && resolvedHandle !== 'all') return resolvedHandle;
        }
        const currentHandle = popupEl.getAttribute('data-current-collection-handle');
        if (currentHandle && currentHandle !== '' && currentHandle !== 'all') return currentHandle;
      }
      const sessionStorageHandle = sessionStorage.getItem('whiteelm_collection_handle');
      if (sessionStorageHandle && sessionStorageHandle !== '') return sessionStorageHandle;
      return '';
    }

    function updatePopupWithCollectionHandle(popupElement, collectionHandle) {
      popupElement.setAttribute('data-original-collection-handle', collectionHandle);
      const contentDiv = popupElement.querySelector('.bag-size-guide__content');
      if (contentDiv) contentDiv.setAttribute('data-collection-content', collectionHandle);
      const shopThisBagBtn = popupElement.querySelector('.bag-size-guide__cta-collection');
      if (shopThisBagBtn && !shopThisBagBtn.hasAttribute('data-add-to-cart')) {
        shopThisBagBtn.setAttribute('href', '/collections/' + collectionHandle);
      }
      const allContentPanels = popupElement.querySelectorAll('.bag-size-guide__collection-content');
      if (allContentPanels.length > 0) {
        let foundMatchingPanel = false;
        allContentPanels.forEach(function (panel) {
          if (panel.getAttribute('data-collection-content') === collectionHandle) {
            panel.classList.add('active');
            foundMatchingPanel = true;
          } else {
            panel.classList.remove('active');
          }
        });
        if (!foundMatchingPanel && allContentPanels.length > 0) {
          allContentPanels[0].classList.add('active');
          allContentPanels[0].setAttribute('data-collection-content', collectionHandle);
        }
      }
      sessionStorage.setItem('whiteelm_collection_handle', collectionHandle);
    }

    function handleUrlChange() {
      if (!originalCollectionHandle) originalCollectionHandle = getCollectionHandleFromUrl();
      const sizeChartPopupElement = document.getElementById('size-chart-popup');
      if (originalCollectionHandle && sizeChartPopupElement) {
        updatePopupWithCollectionHandle(sizeChartPopupElement, originalCollectionHandle);
      }
    }

    originalCollectionHandle = getCollectionHandleFromUrl();
    if (originalCollectionHandle && sizeChartPopup) {
      sizeChartPopup.setAttribute('data-original-collection-handle', originalCollectionHandle);
      sessionStorage.setItem('whiteelm_collection_handle', originalCollectionHandle);
    } else if (!originalCollectionHandle) {
      const storedHandle = sessionStorage.getItem('whiteelm_collection_handle');
      if (storedHandle && storedHandle !== '') {
        originalCollectionHandle = storedHandle;
        sizeChartPopup.setAttribute('data-original-collection-handle', originalCollectionHandle);
      }
    }

    let lastUrl = location.href;
    new MutationObserver(function () {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        handleUrlChange();
      }
    }).observe(document, { subtree: true, childList: true });

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    history.pushState = function () {
      originalPushState.apply(this, arguments);
      handleUrlChange();
    };
    history.replaceState = function () {
      originalReplaceState.apply(this, arguments);
      handleUrlChange();
    };
    window.addEventListener('popstate', handleUrlChange);

    function initDesktopSlider() {
      const sliderPrev = sizeChartPopup.querySelector('.bag-size-guide__slider-prev');
      const sliderNext = sizeChartPopup.querySelector('.bag-size-guide__slider-next');
      const slides = sizeChartPopup.querySelectorAll('.bag-size-guide__slide');
      if (!sliderPrev || !sliderNext || slides.length <= 1) return;
      let currentSlideIndex = 0;
      sliderPrev.addEventListener('click', function () {
        slides[currentSlideIndex].classList.remove('active');
        currentSlideIndex = (currentSlideIndex - 1 + slides.length) % slides.length;
        slides[currentSlideIndex].classList.add('active');
      });
      sliderNext.addEventListener('click', function () {
        slides[currentSlideIndex].classList.remove('active');
        currentSlideIndex = (currentSlideIndex + 1) % slides.length;
        slides[currentSlideIndex].classList.add('active');
      });
    }

    function initViewMoreAnglesButtons() {
      sizeChartPopup.querySelectorAll('.bag-size-guide-mobile-cards__view-more-btn').forEach(function (button) {
        button.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          openAnglesModal(
            bagSizeGuideModal,
            sizeChartPopup,
            this.getAttribute('data-collection'),
            this.getAttribute('data-image-angle'),
            this.getAttribute('data-model-name'),
            this.getAttribute('data-size-title') || '',
            this.getAttribute('data-size-description') || ''
          );
        };
      });
    }

    initViewMoreAnglesButtons();

    document.addEventListener('click', function (e) {
      const sizeGuideLink = e.target.closest('.size-guide__popup');
      if (!sizeGuideLink) return;
      if (
        sizeGuideLink.classList.contains('size-guide__section-link') ||
        sizeGuideLink.getAttribute('data-size-guide-target') === 'section'
      ) {
        return;
      }
      e.preventDefault();
      const sizeChartPopupElement = document.getElementById('size-chart-popup');
      if (!sizeChartPopupElement) return;
      handleUrlChange();
      originalCollectionHandle = getCollectionHandleFromUrl();
      const storedCollectionHandle =
        originalCollectionHandle ||
        sizeChartPopupElement.getAttribute('data-original-collection-handle');
      if (storedCollectionHandle && storedCollectionHandle !== '') {
        updatePopupWithCollectionHandle(sizeChartPopupElement, storedCollectionHandle);
      }
      sizeChartPopupElement.style.display = 'flex';
      sizeChartPopupElement.style.justifyContent = 'center';
      sizeChartPopupElement.style.alignItems = 'center';
      document.body.classList.add('js-drawer-open');
      document.body.style.overflow = 'hidden';
      initDesktopSlider();
      initViewMoreAnglesButtons();
      void sizeChartPopupElement.offsetWidth;
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.size-chart-popup__close')) return;
      const el = document.getElementById('size-chart-popup');
      if (el) {
        el.style.display = 'none';
        document.body.classList.remove('js-drawer-open');
        document.body.style.overflowY = 'scroll';
      }
    });

    document.addEventListener('click', function (e) {
      const el = document.getElementById('size-chart-popup');
      if (el && el.style.display === 'flex' && e.target === el) {
        el.style.display = 'none';
        document.body.classList.remove('js-drawer-open');
        document.body.style.overflowY = 'scroll';
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      const popupEl = document.getElementById('size-chart-popup');
      if (popupEl && popupEl.style.display === 'flex') {
        popupEl.style.display = 'none';
        document.body.classList.remove('js-drawer-open');
        document.body.style.overflowY = 'scroll';
      }
      const modalEl = document.getElementById('bag-size-guide-modal');
      if (modalEl && modalEl.style.display === 'block') {
        modalEl.style.display = 'none';
        document.body.classList.remove('js-drawer-open');
        document.body.style.overflowY = 'scroll';
      }
    });
  }

  function boot() {
    bindSectionScrollLinks();
    initSizeChartPopup();
    initAllProductSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initAllProductSections();
  });
})();
